require("./brokerCryptoTooltip.scss");
//  @vendors
import React from "react";
import { createPortal } from "react-dom";
import PropTypes from 'prop-types'
//  @hooks
import { CryptoTooltipHook } from "./hooks/brokerCryptoTooltip.hook";
import useFocusTrap from "../components/hooks/useFocusTrap";

const CryptoTooltip = ({ content, title }) => {
    const { active, hideTooltip, showTooltip, popoverPosition, tooltipRef } =
        CryptoTooltipHook();
    useFocusTrap(active, tooltipRef);

    return (
        <div className="crypto-tooltip">
            <i
                className="icon icon-informacion tooltip-icon"
                onClick={showTooltip}
                onKeyDown={(e) => e.key === 'Enter' && showTooltip && showTooltip(e)}
                tabIndex={0}
                role="tooltip"
            />
            {createPortal(
                <div
                    className="tooltip-content"
                    ref={tooltipRef}
                    style={{
                        visibility: active ? "visible" : "hidden",
                        left: popoverPosition.left,
                        top: popoverPosition.top,
                    }}
                >
                    <div className="tooltip-header">
                        {title && <span className="tooltip-title">{title}</span>}
                        <div
                            className="tooltip-close-btn" 
                            onClick={() => hideTooltip()}
                            aria-label="Close tooltip"
                            onKeyDown={(e) => e.key === 'Enter' && hideTooltip && hideTooltip()}
                            tabIndex={0}
                            role="tooltipClose"
                        />
                    </div>
                    <span className="tooltip-text">{content}</span>
                </div>,
                document.body
            )}
        </div>
    );
};

CryptoTooltip.propTypes = {
    content: PropTypes.string.isRequired,
};

export { CryptoTooltip };
